import { TEXTS as ADS_TEXTS } from 'application/pages/AdsPage/renderer/texts';

import { AdCampaignMediaTypeEnum } from '@shared/api/graphql/generated';

export const TEXTS = {
  TITLE: 'Загрузка роликов',
  NEXT: 'Далее',
  BACK: 'Назад',
  FILE_TIME_DEFAULT_VALUE: '00:00',
  EXACT_TIME_HINT: 'Укажите в какое время должны выходить рекламные ролики',
  MEDIA_UPLOAD_DESC: ADS_TEXTS.MODAL_AD_CREATE_MEDIA_UPLOAD_DESC,
  INSTANT_UPLOAD_HINT:
    'Вы можете загрузить только один рекламный ролик, так как у рекламной кампании выбран тип «Моментальный ролик»',
};

export const UPLOAD_BUTTON_TEXTS = {
  [AdCampaignMediaTypeEnum.Audio]: ADS_TEXTS.INPUT_AD_CREATE_VIDEO_MEDIA_UPLOAD_TITLE,
  [AdCampaignMediaTypeEnum.Video]: ADS_TEXTS.INPUT_AD_CREATE_VIDEO_MEDIA_UPLOAD_TITLE,
};
